import { useNavigate, useLocation } from 'react-router-dom'

/**
 * Custom hook that provides smart navigation with "already-in-page" check.
 * If already on the target page, it scrolls to top instead of navigating.
 * 
 * @returns A function to navigate to a path with automatic same-page handling
 */
export const useSmartNavigate = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const smartNavigate = (path: string) => {
        // Normalize paths (remove trailing slashes for comparison)
        const currentPath = location.pathname.replace(/\/$/, '') || '/'
        const targetPath = path.replace(/\/$/, '') || '/'

        // Check if we're already on the target page
        if (currentPath === targetPath) {
            // Already on the target page, scroll to top
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        } else {
            // Navigate to the new page
            navigate(path)
        }
    }

    return smartNavigate
}

